<template>
    <v-app-bar
      app
      flat
      dense
      color="blue"
      class="lighten-4"
    >
      <div class="d-flex align-center">
        <v-img
          alt="b and c Logo"
          class="shrink mr-2"
          contain
          :src="require('../assets/logo.png')"
          transition="scale-transition"
          width="40"
        />
      </div>

      <v-spacer></v-spacer>
        <slot></slot>
    </v-app-bar>
</template>

<script>
    export default {
        name: "NavBar.vue"
    }
</script>

<style scoped>

</style>
